import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
	registerTime,
	disqualify,
	dns
} from '../actions/index';

import '../css/App.css';

import {
	FormGroup,
	Alert,
	FormControl,
	Row,
	Grid,
	Col
} from '../../node_modules/react-bootstrap/lib/';

import {
	Pedestrismo,
	PedestrismoBackup
} from '../constants/enums';


class ParticipantRegisterKeyBoard extends Component {

	constructor(props) {

		super(props);


		this.options = {

			defaultSortName:
				'number',

			defaultSortOrder:
				'asc',

			exportCSVText:
				'Exportar CSV',

			noDataText:
				'No hay participantes!'
		};


		this.state = {

			variant:
				'info',

			athlete: {
				fullname:
					'Esperando Dorsal ...'
			},

			value:
				'',

			numberValid:
				false,

			className:
				"form-control",

			validationState:
				null,

			/*
			 * NORMAL
			 * DSQ
			 *
			 * DNS se reconoce directamente
			 * porque el valor comienza con "-".
			 */
			inputMode:
				'NORMAL'
		};


		this.handleChange =
			this.handleChange.bind(this);

		this.handleKeyDown =
			this.handleKeyDown.bind(this);

		this.handleFormSubmit =
			this.handleFormSubmit.bind(this);

		this.getStartOffset =
			this.getStartOffset.bind(this);

		this.canRegisterParticipant =
			this.canRegisterParticipant.bind(this);

		this.resetInput =
			this.resetInput.bind(this);
	}


	isEmpty(obj) {

		for (
			var key in obj
		) {

			if (
				obj.hasOwnProperty(key)
			) {

				return false;
			}
		}


		return true;
	}


	/*
	 * =======================================================
	 * RESET INPUT
	 * =======================================================
	 */
	resetInput() {

		this.setState({

			className:
				"form-control",

			value:
				'',

			athlete: {
				fullname:
					'Esperando Dorsal ...'
			},

			variant:
				'info',

			validationState:
				null,

			inputMode:
				'NORMAL'
		});
	}


	/*
	 * =======================================================
	 * CAPTURA DE TECLA
	 * =======================================================
	 *
	 * El input sigue siendo type="number".
	 *
	 * El navegador no conserva de forma fiable:
	 *
	 * 0125
	 *
	 * Por eso capturamos el primer 0 ANTES de que
	 * llegue al input.
	 *
	 * 0125:
	 *
	 * tecla 0
	 *   ↓
	 * inputMode = DSQ
	 *   ↓
	 * el 0 NO se agrega al input
	 *   ↓
	 * el usuario escribe 125
	 */
	handleKeyDown(e) {

		/*
		 * 0 como PRIMER caracter:
		 *
		 * activa modo DSQ.
		 */
		if (
			e.key === '0' &&
			this.state.value === '' &&
			this.state.inputMode === 'NORMAL'
		) {

			e.preventDefault();


			this.setState({

				inputMode:
					'DSQ',

				variant:
					'warning',

				validationState:
					null,

				athlete: {
					fullname:
						'DSQ - Ingrese dorsal ...'
				}
			});


			return;
		}


		/*
		 * Si activamos DSQ por error y todavía
		 * no escribimos ningún dorsal:
		 *
		 * Backspace cancela el modo.
		 */
		if (
			e.key === 'Backspace' &&
			this.state.value === '' &&
			this.state.inputMode === 'DSQ'
		) {

			e.preventDefault();

			this.resetInput();

			return;
		}


		/*
		 * ESC siempre cancela la operación.
		 */
		if (
			e.key === 'Escape'
		) {

			e.preventDefault();

			this.resetInput();
		}
	}


	/*
	 * =======================================================
	 * CAMBIO DEL INPUT
	 * =======================================================
	 */
	handleChange(e) {

		const value =
			e.target.value;


		let athlete;

		let variant;

		let message = "";

		let validationState;


		/*
		 * ---------------------------------------------------
		 * DNS
		 * ---------------------------------------------------
		 *
		 * -125
		 */
		if (
			String(value).startsWith('-')
		) {

			const number =
				String(value)
					.substring(1);


			athlete =
				this.getAthleteData(
					number
				);


			message = {

				fullname:
					"DNS - No largó: " +
					(
						this.isEmpty(
							athlete
						)
							? ""
							: athlete.fullname
					)
			};


			this.setState({

				validationState:
					this.isEmpty(athlete)
						? 'error'
						: 'warning',

				value,

				athlete:
					message,

				variant:
					this.isEmpty(athlete)
						? 'danger'
						: 'warning',

				className:
					"form-control",

				/*
				 * Si comenzó con "-",
				 * definitivamente no es DSQ.
				 */
				inputMode:
					'NORMAL'
			});


			return;
		}


		/*
		 * ---------------------------------------------------
		 * DSQ
		 * ---------------------------------------------------
		 *
		 * El primer 0 fue capturado por
		 * handleKeyDown().
		 *
		 * En el input solamente veremos:
		 *
		 * 125
		 */
		if (
			this.state.inputMode === 'DSQ'
		) {

			athlete =
				this.getAthleteData(
					value
				);


			message = {

				fullname:
					"DSQ - Va a descalificar a: " +
					(
						this.isEmpty(
							athlete
						)
							? ""
							: athlete.fullname
					)
			};


			this.setState({

				validationState:
					this.isEmpty(athlete)
						? 'error'
						: 'warning',

				value,

				athlete:
					message,

				variant:
					this.isEmpty(athlete)
						? 'danger'
						: 'warning',

				className:
					"form-control"
			});


			return;
		}


		/*
		 * ---------------------------------------------------
		 * LLEGADA NORMAL
		 * ---------------------------------------------------
		 */
		athlete =
			this.getAthleteData(
				value
			);


		variant =
			this.isEmpty(
				athlete
			)
				? "danger"
				: "success";


		message =
			this.isEmpty(
				athlete
			)
				? {
					fullname:
						'Dorsal Incorrecto ...'
				}
				: athlete;


		validationState =
			this.isEmpty(
				athlete
			)
				? "error"
				: "success";


		this.setState({

			validationState,

			value,

			athlete:
				message,

			variant,

			className:
				"form-control"
		});
	}


	/*
	 * =======================================================
	 * POSICION DEL PARTICIPANTE
	 * =======================================================
	 */
	getPositionOf(number) {

		const normalizedNumber =
			String(
				number || ''
			);


		return this.props.participantList.findIndex(
			(participant) => {

				return (
					String(
						participant.number
					) ===
					normalizedNumber
				);
			}
		);
	}


	getValidationState() {

		if (
			this.props.startedAt > 0
		) {

			const valid =
				this.getPositionOf(
					this.state.value
				) > -1;


			if (
				valid
			) {

				return 'success';
			}


			return 'error';
		}


		return null;
	}


	getAthleteData(number) {

		if (
			this.props.startedAt > 0
		) {

			const normalizedNumber =
				String(
					number || ''
				);


			const p =
				this.props.participantList.filter(
					(participant) => {

						return (
							String(
								participant.number
							) ===
							normalizedNumber
						);
					}
				);


			if (
				p != null &&
				p.length > 0
			) {

				return p[0];
			}


			return {};
		}


		return {};
	}


	/*
	 * =======================================================
	 * OFFSET DE LARGADA
	 * =======================================================
	 *
	 * Solo aplica actualmente a Pedestrismo
	 * y PedestrismoBackup.
	 *
	 * DNS y DSQ son independientes de este offset
	 * y funcionan para TODAS las competencias.
	 */
	getStartOffset(participant) {

		if (
			!participant
		) {

			return 0;
		}


		if (
			this.props.competition !== Pedestrismo &&
			this.props.competition !== PedestrismoBackup
		) {

			return 0;
		}


		const participantDistance =
			String(
				participant.distance || ''
			).trim();


		const distance1 =
			String(
				this.props.distance1Type || ''
			).trim();


		const distance2 =
			String(
				this.props.distance2Type || ''
			).trim();


		const distance3 =
			String(
				this.props.distance3Type || ''
			).trim();


		if (
			distance1 !== '' &&
			participantDistance ===
				distance1
		) {

			return Number(
				this.props
					.distance1StartOffset || 0
			);
		}


		if (
			distance2 !== '' &&
			participantDistance ===
				distance2
		) {

			return Number(
				this.props
					.distance2StartOffset || 0
			);
		}


		if (
			distance3 !== '' &&
			participantDistance ===
				distance3
		) {

			return Number(
				this.props
					.distance3StartOffset || 0
			);
		}


		return 0;
	}


	/*
	 * =======================================================
	 * VALIDAR LARGADA
	 * =======================================================
	 *
	 * Solamente aplica a llegada normal.
	 *
	 * DNS y DSQ pueden cargarse independientemente
	 * de la hora de largada.
	 */
	canRegisterParticipant(participant) {

		const startOffset =
			this.getStartOffset(
				participant
			);


		const offsetMs =
			startOffset *
			60 *
			1000;


		const effectiveStart =
			Number(
				this.props.startedAt || 0
			) +
			offsetMs;


		const now =
			new Date().getTime();


		return (
			now >= effectiveStart
		);
	}


	validateNumber() {

		this.setState({

			numberValid:
				this.getPositionOf(
					this.state.value
				) > -1
		});
	}


	/*
	 * =======================================================
	 * SUBMIT
	 * =======================================================
	 */
	handleFormSubmit(e) {

	e.preventDefault();


	const rawValue =
		String(
			this.state.value || ''
		);


	/*
	 * ---------------------------------------------------
	 * DETERMINAR OPERACION
	 * ---------------------------------------------------
	 */

	const isDNS =
		rawValue.startsWith('-');


	const isDSQ =
		this.state.inputMode ===
			'DSQ';


	let participantNumber;


	if (
		isDNS
	) {

		participantNumber =
			rawValue.substring(1);

	} else {

		participantNumber =
			rawValue;
	}


	const index =
		this.getPositionOf(
			participantNumber
		);


	if (
		this.props.startedAt > 0 &&
		index > -1
	) {

		const participant =
			this.props.participantList[
				index
			];


		/*
		 * =================================================
		 * DNS
		 * =================================================
		 *
		 * -125
		 *
		 * Funciona para TODAS las competencias.
		 */
		if (
			isDNS
		) {

			console.log(
				'DNS teclado:',
				participant.number
			);


			setTimeout(
				() => {

					this.props.dns(
						index,
						this.props.competition
					);

				},
				1
			);


			this.resetInput();

			return;
		}


		/*
		 * =================================================
		 * DSQ
		 * =================================================
		 *
		 * 0125
		 *
		 * Funciona para TODAS las competencias.
		 */
		if (
			isDSQ
		) {

			console.log(
				'DSQ teclado:',
				participant.number
			);


			setTimeout(
				() => {

					this.props.disqualify(
						index,
						this.props.competition
					);

				},
				1
			);


			this.resetInput();

			return;
		}


		/*
		 * =================================================
		 * BLOQUEAR LLEGADA SI TIENE ESTADO ESPECIAL
		 * =================================================
		 *
		 * Si el atleta está marcado como:
		 *
		 * DNS
		 * DNF
		 * DSQ
		 *
		 * NO permitimos registrar un tiempo simplemente
		 * ingresando nuevamente su dorsal.
		 *
		 * Para volver a habilitarlo primero debe utilizarse
		 * el reset mediante clic derecho en el botón del
		 * participante.
		 */
		const participantDNS =
			Number(
				participant.dns || 0
			) === 1;


		const participantDNF =
			Number(
				participant.dnf || 0
			) === 1;


		const participantDSQ =
			Number(
				participant.disqualified || 0
			) === 1;


		if (
			participantDNS ||
			participantDNF ||
			participantDSQ
		) {

			let status =
				'';


			if (
				participantDNF
			) {

				status =
					'DNF';

			} else if (
				participantDSQ
			) {

				status =
					'DSQ';

			} else if (
				participantDNS
			) {

				status =
					'DNS';
			}


			/*
			 * Sonido de error
			 */
			if (
				this.props.beep
			) {

				const soundError =
					document.getElementById(
						"audioError"
					);


				if (
					soundError
				) {

					soundError.play();
				}
			}


			this.setState({

				variant:
					'warning',

				validationState:
					'error',

				athlete: {

					fullname:
						participant.fullname +
						' - ' +
						status +
						' - Debe resetear el atleta antes de registrar una llegada'
				}
			});


			console.log(
				'Registro bloqueado por estado:',
				participant.number,
				status
			);
			/*
			* IMPORTANTE:
			*
			* Limpiamos inmediatamente el dorsal ingresado
			* para permitir ingresar el siguiente atleta.4
			* 
			*/
			this.resetInput();

			return;
		}


		/*
		 * =================================================
		 * LLEGADA NORMAL
		 * =================================================
		 */

		const startOffset =
			this.getStartOffset(
				participant
			);


		/*
		 * La validación del offset
		 * solamente corresponde a llegada.
		 */
		if (
			!this.canRegisterParticipant(
				participant
			)
		) {

			if (
				this.props.beep
			) {

				const soundError =
					document.getElementById(
						"audioError"
					);


				if (
					soundError
				) {

					soundError.play();
				}
			}


			this.setState({

				variant:
					'warning',

				validationState:
					'error',

				athlete: {

					fullname:
						participant.fullname +
						' - Su distancia todavía no largó'
				}
			});


			console.log(
				'Registro bloqueado:',
				participant.number,
				'Distancia:',
				participant.distance,
				'Offset:',
				startOffset,
				'min'
			);


			return;
		}


		/*
		 * SONIDO OK
		 */
		if (
			this.props.beep
		) {

			const sound =
				document.getElementById(
					"audioOK"
				);


			if (
				sound
			) {

				sound.play();
			}
		}


		console.log(
			'Registro teclado:',
			participant.number,
			'Distancia:',
			participant.distance,
			'Offset:',
			startOffset,
			'min'
		);


		setTimeout(
			() => {

				this.props.registerTime(
					index,
					this.props.competition,
					startOffset
				);

			},
			1
		);


	} else {

		/*
		 * DORSAL INCORRECTO
		 */
		if (
			this.props.beep
		) {

			const soundError =
				document.getElementById(
					"audioError"
				);


			if (
				soundError
			) {

				soundError.play();
			}
		}
	}


	this.resetInput();
}

	render() {

		return (

			<Grid>

				<Row className="show-grid">

					<Col md={6}>

						<form
							name="audio"
							onSubmit={
								this.handleFormSubmit
							}
						>

							<FormGroup
								controlId="formBasicText"
								validationState={
									this.state
										.validationState
								}
								bsSize="large"
							>

								<FormControl
									type="number"

									value={
										this.state.value
									}

									placeholder={
										this.state.inputMode ===
											'DSQ'
											? 'DSQ - número...'
											: 'número...'
									}

									onKeyDown={
										this.handleKeyDown
									}

									onChange={
										this.handleChange
									}

									bsSize="large"
								/>

								<FormControl.Feedback />

							</FormGroup>

						</form>

					</Col>


					<Col md={6}>

						<Alert
							bsStyle={
								this.state.variant
							}
						>

							<div
								className="close"
								data-dismiss="alert"
								aria-label="close"
							>

								{
									this.state
										.athlete
										.catName
								}

							</div>


							{
								this.state
									.validationState !==
									'error'
								&&
								this.state
									.validationState !==
									null
								&&
								this.state
									.inputMode ===
									'NORMAL'
								&&
								!String(
									this.state.value
								).startsWith('-')
									? 'Llegando '
									: ''
							}


							{
								this.state
									.athlete
									.fullname
							}


							{
								this.state
									.validationState !==
									null
									? ' ...'
									: ''
							}

						</Alert>

					</Col>

				</Row>

			</Grid>
		);
	}
}


function mapDispatchToProps(
	dispatch
) {

	return bindActionCreators(
		{
			registerTime,
			disqualify,
			dns
		},
		dispatch
	);
}


function mapStateToProps(
	state
) {

	const {
		participantList
	} =
		state.reducerRegisterTime;


	const {
		startedAt
	} =
		state.reducerTimer;


	const {
		competition,

		beep,

		distance1Type,
		distance1StartOffset,

		distance2Type,
		distance2StartOffset,

		distance3Type,
		distance3StartOffset

	} =
		state.reducerRegisterInfo;


	return {

		startedAt,

		participantList,

		competition,

		beep,

		distance1Type,
		distance1StartOffset,

		distance2Type,
		distance2StartOffset,

		distance3Type,
		distance3StartOffset
	};
}


export default connect(
	mapStateToProps,
	mapDispatchToProps
)(
	ParticipantRegisterKeyBoard
);



// WEBPACK FOOTER //
// ./src/containers/participant-list-keyboard.js